import { environment } from './../../../../environments/environment';
import { Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import { AnalyticsService } from '../../../common/services/analytics.service';
import { ModalService } from '../modal.service';

declare var $: any;

/**
 * This class represents the information modal component
 */
@Component({
    selector: 'consider-tsa-modal',
    templateUrl: 'consider-tsa-modal.component.html',
    standalone: false
})

export class ConsiderTsaModalComponent implements OnInit {

  private _proceedWithUPBtn: HTMLElement;
  private _goToTSABtn: HTMLElement;

  public TSA_LOGIN_URL = environment.tsaLoginURL;

  constructor(private analyticsService: AnalyticsService, private modalService: ModalService) {
    modalService.considerTSA  = this.considerTSA.bind(this);
  }

  ngOnInit() {
    this._proceedWithUPBtn = document.getElementById('proceedWithUPBtn');
    this._goToTSABtn = document.getElementById('goToTSABtn');
  }

  considerTSA() : Promise<boolean> {
    const promise = new Promise<boolean>(resolve => {
      this._configureModal(resolve);
    });
    return promise;
  }

  public logGetStartedProgram(programName: string) {
    if (programName) {
      this.analyticsService.logGetStarted(programName).subscribe();
    }
  }

  public showSiteLeavingToTSAModal() {
      $('#mdl-tsa-site-leaving').modal('show');
  }

  private _configureModal(resolve: (x: boolean) => any) {
    const confirmed = (e: Event) => resolve(true);
    const cancelled = (e: Event) => resolve(false);
    if (!this._proceedWithUPBtn || !this._goToTSABtn) {return cancelled(null);}

    this._proceedWithUPBtn.onclick = ((e: Event) => {
      e.preventDefault();
      $('#considerTSAModal').modal('hide');
      confirmed(e);
    });

    this._goToTSABtn.onclick = ((e: Event) => {
      e.preventDefault();
      $('#considerTSAModal').modal('hide');
      this.showSiteLeavingToTSAModal();
      cancelled(e);
    });

    $('#considerTSAModal').modal('show');
  }
}
